// extracted by mini-css-extract-plugin
export default {"price":"V6-z","priceRow":"W6-z","onSale":"X6-z","msrpLabelPrice":"Y6-z","msrpLabel":"Z6-z","originalPrice":"_6-z","percentOff":"a7-z"};